import classNames from 'classnames/bind';

import styles from './T02_oh-my-green.module.scss';
import nolabel01 from '../../assets/images/brand/think-green/nolabel-01.png';
import nolabel02 from '../../assets/images/brand/think-green/nolabel-02.png';
import nolabel03 from '../../assets/images/brand/think-green/nolabel-03.jpg';
import recycle from '../../assets/images/brand/think-green/recycle.png';

const cx = classNames.bind(styles);

const ThinkGreen = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('pageTitle')}>
        <img src={require('../../assets/images/brand/think-green/oh-my-green.png')} alt="Oh My Green" />
      </div>
      <div className={cx(['section', 'top'])}>
        <div className={cx('limiter')}>
          <h3>
            탄소 배출량을 줄여
            <br /> 환경까지 생각하는 경량 패키지
          </h3>
          <div className={cx('center')}>
            <div className={cx(['desc', 'fisrt'])}>
              <h4>
                <span className={cx('title')}>경량 용기</span>
              </h4>
              <p>
                - 2L: 기존 대비 플라스틱 4.5g 저감
                <br />- 500ml: 기존 대비 플라스틱 2.3g 저감
              </p>
            </div>
            <div className={cx(['desc', 'second'])}>
              <h4>
                <span className={cx('title')}>경량 뚜껑</span>
              </h4>
              <p>
                기존 대비
                <br />
                플라스틱 0.5g 저감
              </p>
            </div>
            <div className={cx('bottle')}></div>
          </div>
          <div className={cx('text')}>
            <p>
              풀무원샘물은 제품 포장 경량화를 지속적으로 추진하고 있습니다.
              <br />
              경량 뚜껑과 경량 용기를 개발하여 포천 이동공장에서 생산하는 2L와 500mL 제품에 대해 환경부 ‘저탄소 제품’ 인증을 취득하였습니다.
            </p>
          </div>
        </div>
      </div>
      <div className={cx(['section', 'center'])}>
        <div className={cx('limiter')}>
          <h3>무라벨 제품 정보 표기</h3>
          <ul className={cx('list')}>
            <li>
              <img src={nolabel01} alt="낱병" />
              <div className={cx('info')}>
                <p>수원지, 제조일, 고객센터 번호</p>
              </div>
            </li>
            <li>
              <img src={nolabel02} alt="팩 전면" />
              <div className={cx('info')}>
                <h4>팩 전면</h4>
                <p>수원지 정보</p>
              </div>
            </li>
            <li>
              <img src={nolabel03} alt="팩 후면" />
              <div className={cx('info')}>
                <h4>팩 후면</h4>
                <p>무기물질함량, 제품 상세 정보</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className={cx(['section', 'bottom'])}>
        <div className={cx('limiter')}>
          <h3>
            생산부터 재활용까지 모든 단계에서
            <br /> 탄소 저감 노력 실천, 저탄소 인증
          </h3>
          <img src={recycle} alt="" />
          <p>
            풀무원샘물은 제품 용기의 경량화뿐만 아니라 제품이 생산되고 소비자가 소비한 후
            <br /> 재활용되는 모든 단계에서 탄소 배출량을 줄이고자 노력하고 있습니다.
            <br /> 이러한 환경을 생각하는 풀무원샘물의 연구와 노력은 지금도 쉬지 않고 계속되고 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThinkGreen;
